/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormWrapper.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */


import React, { useContext } from 'react';
import { FormContext } from "@proxy/_contexts";
import { isEnabled } from "@root/_utils";

type FormWrapperProps = {
  formTheme: string;
  children: React.ReactNode;
}

const FormWrapper = ({
  formTheme,
  children,
}: FormWrapperProps) => {

  const {
    settings,
    bulkOrder,
    styleVars,
  } = useContext(FormContext);

  const previewHidden = (
    !isEnabled(settings.digital.appearance.enable_email_preview) &&
    !isEnabled(settings.digital.appearance.enable_landing_preview)
  );

  return ((bulkOrder) ?
    <div style={styleVars}>
      {children}
    </div>
  :
    <div
      id="gcpPageWrapper"
      className={(previewHidden) ? "gcp__no-preview" : undefined}
      style={styleVars}
    >
      <div
        className={(formTheme !== "product_template")
          ? "page-width site-wrapper wrapper main-content container gc__page_wrapper"
          : undefined
        }
        data-theme={formTheme}
      >
        {children}
      </div>
    </div>
  );
};

export default FormWrapper;
